export enum LEVELS {
  VERY_LOW = "Very Low",
  LOW = "Low",
  AVERAGE = "Average",
  HIGH = "High",
  VERY_HIGH = "Very High",
}
